import { render } from "./edit.vue?vue&type=template&id=ade2a666&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=ade2a666&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade2a666"]])

export default __exports__